import { React, useState, useContext, useEffect, useCallback, useMemo } from "react";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import "./hierarchy-nodes.scss";
import { Button, Flex, Select, MTable, Text, useRowSelection } from "@cisco/spaces-dash-lib-styleguide";
import { useSelector } from "react-redux";
import { I18nContext } from "../../contexts/i18nContext";
// import { getTimeZone } from "../../service/timezone-service";
import useNotification from "../../hooks/useNotification";
import CreateGroupPopup from "./create-group-popup";
import { createGroupLh2 } from "../../service/business-hierarchy-service";
import useLoader from "../../hooks/useLoader";
import UngroupPopup from "./ungroup-popup";

function HierarchyNodes(props) {
  const i18n = useContext(I18nContext);
  const { t } = i18n;
  const { setToastMessage } = useNotification();
  const { setLoading } = useLoader();
  const { selectedNodeValue: selectedNode, setModalOpened } = props;
  const { selectedRows, setRowSelection } = useRowSelection();
  // const [selectedNode, setSelectedNode] = useState(selectedNodeValue);
  const [nodeData, setNodeData] = useState(null);
  // const [selectedIndex, setSelectedIndex] = useState(-1);
  // const [selectedNodeLevel, setSelectedNodeLevel] = useState(1);
  // const [firstLevelNodeCount, setFirstLevelNodeCount] = useState(0);
  // const [secondLevelNodeCount, setSecondLevelNodeCount] = useState(0);
  // const [cSelectorVisible, setCSelectorVisible] = useState(false);
  const [selectedNodeArr, setSelectedNodeArr] = useState([]);
  // const [editFieldValue, setEditFieldValue] = useState({
  //   totalCapacity: null,
  //   totalArea: null,
  //   inferredTimeZoneId: null
  // });
  const [groupPopupVisible, setGroupPopupVisible] = useState(false);
  const [unGroupPromptVisible, setUnGroupPromptVisible] = useState(false);
  const [btnVisible, setBtnVisible] = useState({
    group: false,
    ungroup: false
  });
  const [groupName, setGroupName] = useState(null);
  const [selectedGroupData, setSelectedGroupData] = useState([]);
  const columnModel = useMemo(
    () => ({
      SELECT: { text: i18n.t("hierarchy-nodes.select-all-text"), display: true },
      TYPE: { text: i18n.t("hierarchy-nodes.type-text"), display: true },
      HIERARCHY: {
        text: i18n.t("hierarchy-nodes.hierarchy-text"),
        display: true
      },
      MAX_CAPACITY: {
        text: i18n.t("hierarchy-nodes.max-capacity-text"),
        display: true
      },
      TOTAL_AREA: {
        text: i18n.t("hierarchy-nodes.total-area-text'"),
        display: true
      },
      TIME_ZONE: {
        text: i18n.t("hierarchy-nodes.timezone-small-text"),
        display: true
      },
      APS: { text: i18n.t("hierarchy-nodes.aps-text"), display: true },
      CAMERA: { text: i18n.t("hierarchy-nodes.camera-text"), display: true }
    }),
    [i18n]
  );
  // const [columnModelCopy, setColumnModelCopy] = useState({});
  // const [activeNodeData, setActiveNodeData] = useState(null);
  // const [fullHierarchyPath, setFullHierarchyPath] = useState(null);
  const [nodesBelow, setNodesBelow] = useState([]);
  const [selectedLevelDown, setSelectedLevelDown] = useState([1]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [filteredLevelLocations, setFilteredLevelLocations] = useState([]);
  const [locAr, setLocAr] = useState([]);
  const [locTypes, setLocTypes] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  // const [selectedLocationUniqueCount, setSelectedLocationUniqueCount] = useState([]);
  // const [showMetadataBulkUpdate, setShowMetadataBulkUpdate] = useState(false);
  // const [locationMetadata, setLocationMetadata] = useState([]);
  // const [showBulkUpdateFilter, setShowBulkUpdateFilter] = useState(false);
  // const [editingNode, setEditingNode] = useState({
  //   name: {
  //     type: "",
  //     value: ""
  //   },
  //   brandName: {
  //     type: "",
  //     value: ""
  //   },
  //   address: {
  //     type: "",
  //     value: ""
  //   },
  //   specifiedTimeZoneId: {
  //     type: "",
  //     value: ""
  //   },
  //   totalArea: {
  //     type: "",
  //     value: ""
  //   },
  //   totalCapacity: {
  //     type: "",
  //     value: ""
  //   },
  //   totalAreaUnit: {
  //     type: "",
  //     value: ""
  //   },
  //   latitude: {
  //     type: "",
  //     value: ""
  //   },
  //   longitude: {
  //     type: "",
  //     value: ""
  //   },
  //   locationId: {
  //     type: "",
  //     value: ""
  //   }
  // });
  // const [locationsForEdit, setLocationsForEdit] = useState([]);
  // const [showEditPopup, setShowEditPopup] = useState(false);
  // const [showValidationError, setShowValidationError] = useState(false);
  // const [sideNavZindex, setSideNavZindex] = useState("0");
  const naText = i18n.t("hierarchy-nodes.na-text");

  const locationMap = useSelector((state) => state.locationRowMap);

  const getLocationRowMap = useCallback(() => locationMap, [locationMap]);
  const getLocationRowMapByKey = useCallback((key) => locationMap && locationMap[key], [locationMap]);

  // const getNodeCounts = (tempNodeData) => {
  //   setFirstLevelNodeCount(tempNodeData?.length);
  //   let secondLevelCount = 0;
  //   tempNodeData?.forEach((node) => {
  //     if (node?.childData) secondLevelCount += node.childData.length;
  //   });
  //   setSecondLevelNodeCount(secondLevelCount);
  // };

  const resetSelectedData = () => {
    setBtnVisible({ group: false, ungroup: false });
    setSelectedNodeArr([]);
    setRowSelection({});
  };

  // const nodeLevelSelected = (index) => {
  //   setSelectedNodeLevel(index);

  //   if (index === 2) {
  //     const children = [...nodeData];
  //     const newNodes = [];

  //     children.forEach((child) => {
  //       child.childData.forEach((node) => {
  //         const childID = node.id;
  //         const childDetails = getLocationRowMapByKey(childID);
  //         newNodes.push(childDetails);
  //       });
  //     });

  //     setNodeData(newNodes);
  //   } else if (index === 1) {
  //     const children = selectedNode.data && selectedNode.data.childData ? selectedNode.data.childData : [];
  //     const newNodes = [];

  //     children.forEach((child) => {
  //       const childID = child.id;
  //       const childDetails = getLocationRowMapByKey(childID);
  //       newNodes.push(childDetails);
  //     });

  //     setNodeData(newNodes);
  //     getNodeCounts(newNodes);
  //   }

  //   resetSelectedData();
  // };

  // const doubleClick = (node, index) => {
  //   if (selectedIndex === -1) {
  //     setActiveNodeData(node);
  //     setSelectedIndex(index);
  //   } else {
  //     // TODO:
  //     console.log("complete selected operation");
  //   }
  //   setCSelectorVisible(false);
  // };

  // const timeZoneSelected = (data) => {
  //   const timeZone = data.split(":")[0];
  //   setEditFieldValue((prevState) => ({
  //     ...prevState,
  //     inferredTimeZoneId: timeZone
  //   }));
  // };

  const getTotalArea = (node) => {
    let totalArea;
    if (node.totalArea) {
      totalArea = node.totalArea;
    } else {
      totalArea = selectedNode.data && selectedNode.data.totalArea ? selectedNode.data.totalArea : "";
    }
    if (totalArea) {
      if (totalArea % 1 === 0) {
        return totalArea;
      }
      return parseFloat(totalArea).toFixed(2);
    }
    return naText;
  };

  const getMaxCapacity = (node) => {
    if (node.totalCapacity) {
      return node.totalCapacity;
    }
    return selectedNode.data && selectedNode.data.totalCapacity ? selectedNode.data.totalCapacity : naText;
  };

  // const cancelActiveNode = () => {
  //   setSelectedIndex(-1);
  //   setActiveNodeData(null);
  //   setEditFieldValue({
  //     inferredTimeZoneId: null,
  //     totalArea: null,
  //     totalCapacity: null
  //   });
  // };

  // const validateConfig = (data) => {
  //   if (data.totalCapacity < 0) {
  //     return false;
  //   }
  //   if (data.totalArea < 0) {
  //     return false;
  //   }
  //   return true;
  // };

  // const updateActiveNodeData = () => {
  //   console.log(editFieldValue);
  //   console.log(activeNodeData);
  //   const status = validateConfig(editFieldValue);

  //   if (status) {
  //     const payload = {
  //       name: activeNodeData.name,
  //       brandName: activeNodeData.brandName ? activeNodeData.brandName : "",
  //       address: activeNodeData.address ? activeNodeData.address : "",
  //       timeZoneId: activeNodeData.inferredTimeZoneId ? activeNodeData.inferredTimeZoneId : "",
  //       totalAreaValue: activeNodeData.totalArea ? activeNodeData.totalArea : "",
  //       totalCapacity: activeNodeData.totalCapacity ? activeNodeData.totalCapacity.toString() : "",
  //       totalAreaUnit: "Square Feet",
  //       latitude: activeNodeData.latitude ? activeNodeData.latitude : null,
  //       longitude: activeNodeData.longitude ? activeNodeData.longitude : null,
  //       locationId: activeNodeData.id
  //     };

  //     if (editFieldValue.totalCapacity) {
  //       setActiveNodeData((prev) => ({
  //         ...prev,
  //         totalCapacity: editFieldValue.totalCapacity
  //       }));
  //       payload.totalCapacity = editFieldValue.totalCapacity.toString();
  //     }
  //     if (editFieldValue.totalArea) {
  //       setActiveNodeData((prev) => ({
  //         ...prev,
  //         totalArea: editFieldValue.totalArea
  //       }));
  //       payload.totalAreaValue = editFieldValue.totalArea;
  //     }
  //     if (editFieldValue.inferredTimeZoneId) {
  //       setActiveNodeData((prev) => ({
  //         ...prev,
  //         inferredTimeZoneId: editFieldValue.inferredTimeZoneId
  //       }));
  //       payload.timeZoneId = editFieldValue.inferredTimeZoneId;
  //     }

  //     setActiveNodeData({ ...activeNodeData });
  //   }
  // };

  // const getClassName = (node) => {
  //   if (node && node.type && node.type.length) {
  //     return `type-${node.type[0].toLowerCase()}`;
  //   }
  //   return "";
  // };

  const getHierarchyName = (name) => {
    const nameStr = `...${selectedNode && selectedNode.data && selectedNode.data.name ? selectedNode.data.name : "Unknown"} > ${name}`;
    return nameStr;
  };

  // const applyCSelector = () => {
  //   const newColumnModel = { ...columnModel };
  //   Object.keys(columnModelCopy).forEach((key) => {
  //     newColumnModel[key].display = columnModelCopy[key];
  //   });
  //   setColumnModel(newColumnModel);
  //   setCSelectorVisible(false);
  // };

  // const resetCS = () => {
  //   const newColumnModel = { ...columnModel };
  //   Object.keys(newColumnModel).forEach((key) => {
  //     newColumnModel[key].display = true;
  //   });
  //   setColumnModel(newColumnModel);
  //   setCSelectorVisible(false);
  // };

  // const toggleColumnBlock = (key) => {
  //   setColumnModelCopy((prevState) => ({
  //     ...prevState,
  //     [key]: !columnModel[key].display
  //   }));
  // };

  // const toggleCSelector = () => {
  //   setCSelectorVisible((prev) => !prev);
  // };

  const getSelectedGroupData = (ids) => {
    const arr = [];
    if (nodeData?.length > 0) {
      ids.forEach((id) => {
        nodeData.forEach((node) => {
          if (id == node.id) {
            const data = {
              id,
              name: node.name
            };
            arr.push(data);
          }
        });
      });
    }
    return arr;
  };

  const openCreateGroupPopup = () => {
    setSelectedGroupData([]);
    if (selectedLocations.length > 0) {
      let sameParent = true;
      const parentLoc = [];
      selectedLocations.forEach((loc) => {
        if (parentLoc.length > 0 && parentLoc.indexOf(loc.parentId) === -1) {
          sameParent = false;
        } else {
          parentLoc.push(loc.parentId);
        }
      });
      if (sameParent) {
        setSelectedGroupData(getSelectedGroupData(selectedNodeArr));
        setGroupPopupVisible(true);
        setModalOpened(true);
      } else {
        setToastMessage(t("hierarchy-nodes.cannot-create-group-on-locations-different-parent-node-msg"), 5000, "negative");
        setModalOpened(false);
        setGroupPopupVisible(false);
      }
    }
  };

  const closeGroupPopup = () => {
    setGroupPopupVisible(false);
    setModalOpened(false);
  };

  const toggleUngroupConfirmation = () => {
    setUnGroupPromptVisible((prev) => !prev);
  };

  const createGroup = async () => {
    if (groupName) {
      setLoading(true);
      const selectedGroup = getSelectedGroupData(selectedNodeArr);
      const payload = {
        locations: selectedGroup,
        name: groupName,
        type: "group",
        locationId: nodeData && nodeData.length > 0 && nodeData[0] ? nodeData[0].parentId : null,
        action: "add"
      };

      try {
        const res = await createGroupLh2(payload);
        if (res && res.status) {
          setLoading(false);
          setToastMessage("Group created successfully", 5000, "positive");
          setGroupName(null);
          resetSelectedData();
          closeGroupPopup();
        } else {
          setLoading(false);
          setToastMessage(res.message, 5000, "negative");
          closeGroupPopup();
        }
      } catch (error) {
        setLoading(false);
        setToastMessage("Failed to create group", 5000, "negative");
        console.error("Error creating group", error);
        closeGroupPopup();
      }
    } else {
      setToastMessage(t("hierarchy-nodes.please-enter-group-name-text"), 5000, "negative");
    }
  };

  const ungroupSelectedNode = async () => {
    const selectedGroup = getSelectedGroupData(selectedNodeArr);
    const payload = {
      locations: [],
      name: selectedGroup[0].name,
      type: "group",
      locationId: selectedNodeArr[0],
      action: "edit"
    };

    try {
      setLoading(true);
      const res = await createGroupLh2(payload);
      if (!res.status) {
        setLoading(false);
        setToastMessage(res.message, 5000, "negative");
        toggleUngroupConfirmation();
        return;
      }
      if (res) {
        setLoading(false);
        setToastMessage(t("hierarchy-nodes.ungrouped-success-msg"), 5000, "positive");
        resetSelectedData();
        toggleUngroupConfirmation();
      }
    } catch (error) {
      setLoading(false);
      setToastMessage("Failed to delete group", 5000, "negative");
      console.error("Error deleting group", error);
      toggleUngroupConfirmation();
    }
  };

  // const getParentIdStr = (data, str) => {
  //   const node = getLocationRowMapByKey(data.parentId);
  //   str = node ? `${node.name} > ${str}` : "";
  //   if (node.parentId == "-1") {
  //     return str;
  //   }
  //   return getParentIdStr(node, str);
  // };

  // const getFullHierarchyPath = (node) => {
  //   let str = null;
  //   let fullStr = null;
  //   if (selectedNode.data && selectedNode.data.name && selectedNode.data.parentId != "-1") {
  //     str = `${selectedNode.data.name} > ${node.name}`;
  //     fullStr = getParentIdStr(selectedNode.data, str);
  //   } else {
  //     fullStr = selectedNode.data && selectedNode.data.name ? `${selectedNode.data.name} > ${node.name}` : node.name;
  //   }
  //   setFullHierarchyPath(fullStr);
  //   return fullStr;
  // };

  // const [selectedNodeDetails, setSelectedNodeDetails] = useState({
  //   latitude: null,
  //   longitude: null
  // });

  const listNodes = () => {
    const newFilteredLevelLocations = [];
    const newLocTypes = [];
    const locations = locAr.filter((e) => {
      if (e.locationPath && selectedNode && selectedNode.data && selectedNode.data.id && e.locationPath.indexOf(selectedNode.data.id) > -1) {
        const parentIndex = e.locationPath.indexOf(selectedNode.data.id);
        for (let i = 0; i < selectedLevelDown.length; i++) {
          const nodeDepth = parentIndex + selectedLevelDown[i] + 1;
          if (e.locationPath.length === nodeDepth) {
            newFilteredLevelLocations.push(e);
            if (newLocTypes.indexOf(e.type[0]) === -1) {
              newLocTypes.push(e.type[0]);
            }
            if (selectedTypes.length) {
              for (let j = 0; j < selectedTypes.length; j++) {
                const type = selectedTypes[j];
                if (e.type && e.type.indexOf(type) > -1) {
                  return e;
                }
              }
            }
          }
        }
      }
      return null;
    });
    setNodeData(locations);
    setFilteredLevelLocations(newFilteredLevelLocations);
    // compare the locTypes with newLocTypes
    if (locTypes.length !== newLocTypes.length) {
      setLocTypes(newLocTypes);
    }
    // getNodeCounts(locations);
  };

  const getLevel = () => {
    if (nodesBelow.length && selectedLevelDown.length === nodesBelow.length) {
      return "All";
    }
    if (nodesBelow.length && selectedLevelDown.length > 1) {
      return "Multi level";
    }
    if (nodesBelow.length && selectedLevelDown.length === 1) {
      return `${selectedLevelDown[0]} level`;
    }
    if (nodesBelow.length === 0 || selectedLevelDown.length === 0) {
      return "-";
    }
    return "-";
  };

  const isChecked = (level) => {
    if (level === "all") {
      if (selectedLevelDown.length === nodesBelow.length) {
        return true;
      }
    } else if (selectedLevelDown?.indexOf(level) > -1) {
      return true;
    }
    return false;
  };

  const toggleFilter = (data) => {
    // if (isChecked(data)) {
    //   setSelectedLevelDown((prev) => prev.filter((level) => level !== data));
    // } else {
    //   setSelectedLevelDown((prev) => [...prev, data]);
    // }
    setSelectedLevelDown(data);
  };

  const clearFilter = () => {
    setSelectedLevelDown([]);
  };

  const clearTypeFilter = () => {
    setSelectedTypes([]);
  };

  const getType = () => {
    if (locTypes.length && selectedTypes.length === locTypes.length) {
      return "All";
    }
    if (selectedTypes.length > 1) {
      return "Multiple types";
    }
    if (selectedTypes.length === 1) {
      return selectedTypes[0];
    }
    if (selectedTypes.length === 0) {
      return "-";
    }
    return "-";
  };

  const isTypeChecked = (type) => {
    if (type === "all") {
      if (selectedTypes.length === locTypes.length) {
        return true;
      }
    } else if (selectedTypes.indexOf(type) > -1) {
      return true;
    }
    return false;
  };

  const toggleType = (type) => {
    // if (isTypeChecked(type)) {
    //   setSelectedTypes((prev) => prev.filter((data) => data !== type));
    // } else {
    //   setSelectedTypes((prev) => [...prev, type]);
    // }
    setSelectedTypes(type);
  };

  // const toggleUpdateFilter = () => {
  //   setShowBulkUpdateFilter((prev) => !prev);
  // };

  // const locationInfoForBulkUpdate = (type) => {
  //   if (selectedNodeArr.length > 0) {
  //     toggleUpdateFilter();
  //     // dataService.display(true);
  //     const payload = {
  //       locationIds: selectedNodeArr,
  //       info: type
  //     };
  //     const selectedLocationUniqueMap = {};
  //     selectedLocations.forEach((location) => {
  //       if (selectedLocationUniqueMap[location.type[0]]) {
  //         selectedLocationUniqueMap[location.type[0]] += 1;
  //       } else {
  //         selectedLocationUniqueMap[location.type[0]] = 1;
  //       }
  //     });
  //     const newSelectedLocationUniqueCount = [];
  //     Object.keys(selectedLocationUniqueMap).forEach((locType) => {
  //       newSelectedLocationUniqueCount.push({
  //         type: locType,
  //         count: selectedLocationUniqueMap[locType]
  //       });
  //     });
  //     setSelectedLocationUniqueCount(newSelectedLocationUniqueCount);
  //   }
  // };

  // const prepareMetaDataBulkUpdate = (metadata) => {
  //   console.log("Metadata for bulk update:: ", metadata);
  //   setShowMetadataBulkUpdate(true);
  //   setLocationMetadata(metadata);
  // };

  // const prepareLocationBulkUpdate = (locations) => {
  //   console.log("Locations info for bulk update:: ", locations);
  //   const locIds = Object.keys(locations);
  //   if (locIds && locIds.length) {
  //     if (locIds.length === 1) {
  //       const singleLocId = locIds[0];
  //       if (locations[singleLocId] && locations[singleLocId].latitude && locations[singleLocId].longitude) {
  //         setSelectedNodeDetails({
  //           ...selectedNodeDetails,
  //           latitude: locations[singleLocId].latitude,
  //           longitude: locations[singleLocId].longitude
  //         });
  //       }
  //     }
  //     locIds.forEach((id) => {
  //       const locationData = locations[id];
  //       Object.keys(locationData).forEach((key) => {
  //         const newEditingNode = { ...editingNode };
  //         if (editingNode[key] && editingNode[key].value) {
  //           newEditingNode[key] = {
  //             ...newEditingNode[key],
  //             type: "multiple",
  //             value: ""
  //           };
  //           if (key === "specifiedTimeZoneId") {
  //             setSelectedTimeZone({ name: "Multiple Values" });
  //           }
  //           if (key === "totalAreaUnit") {
  //             setTotalAreaUnit({ name: "Multiple Values" });
  //           }
  //         } else {
  //           newEditingNode[key] = {
  //             ...newEditingNode[key],
  //             type: "single",
  //             value: locationData[key]
  //           };
  //           if (key === "specifiedTimeZoneId") {
  //             setSelectedTimeZone({ name: locationData[key] });
  //           }
  //           if (key === "totalAreaUnit") {
  //             setTotalAreaUnit({ name: locationData[key] });
  //           }
  //         }
  //         setEditingNode(newEditingNode);
  //       });
  //       setShowEditPopup(true);
  //     });
  //   }
  // };

  // const closeMetaDataBulkUpdate = () => {
  //   setShowMetadataBulkUpdate(false);
  // };

  // const onTimeZoneChange = (evt) => {
  //   setSelectedTimeZone({ name: evt.name });
  //   setEditingNode({
  //     ...editingNode,
  //     specifiedTimeZoneId: {
  //       ...editingNode.specifiedTimeZoneId,
  //       type: "single",
  //       value: evt.name
  //     }
  //   });
  // };

  // const onChooseLocation = (coords) => {
  //   setEditingNode({
  //     ...editingNode,
  //     latitude: {
  //       ...editingNode.latitude,
  //       value: coords.latitude
  //     },
  //     longitude: {
  //       ...editingNode.longitude,
  //       value: coords.longitude
  //     }
  //   });
  // };

  // const resetEditPopup = () => {
  //   setEditingNode({
  //     name: { type: "", value: "" },
  //     brandName: { type: "", value: "" },
  //     address: { type: "", value: "" },
  //     specifiedTimeZoneId: { type: "", value: "" },
  //     totalArea: { type: "", value: "" },
  //     totalCapacity: { type: "", value: "" },
  //     totalAreaUnit: { type: "", value: "" },
  //     latitude: { type: "", value: "" },
  //     longitude: { type: "", value: "" },
  //     locationId: { type: "", value: "" }
  //   });
  //   setSelectedTimeZone({
  //     name: i18n.t("hierarchy-nodes.select-timezone-text")
  //   });
  //   setLocationsForEdit([]);
  //   setTotalAreaUnit({ name: i18n.t("hierarchy-nodes.square-feet-text") });
  // };

  // const hideEditLocationPopup = () => {
  //   resetEditPopup();
  //   setShowEditPopup(false);
  // };

  // const validateTotalArea = () => {
  //   if (editingNode.totalAreaUnit.value === "Square Feet") {
  //     const totalArea = parseFloat(editingNode.totalArea.value);
  //     if (totalArea < 100 || totalArea > 1000000) {
  //       setShowValidationError(true);
  //       return false;
  //     }
  //     setShowValidationError(false);
  //     return true;
  //   }
  //   if (editingNode.totalAreaUnit.value === "Square Meter") {
  //     const totalArea = parseFloat(editingNode.totalArea.value);
  //     if (totalArea < 9.2903 || totalArea > 92903.04) {
  //       setShowValidationError(true);
  //       return false;
  //     }
  //     setShowValidationError(false);
  //     return true;
  //   }
  //   setShowValidationError(false);
  //   return true;
  // };

  // const onUnitChange = (evt) => {
  //   setEditingNode({
  //     ...editingNode,
  //     totalAreaUnit: {
  //       value: evt.name,
  //       type: "single"
  //     }
  //   });
  //   validateTotalArea();
  // };

  // const saveLocation = () => {
  //   if (selectedNodeArr?.length && editingNode) {
  //     if (!validateTotalArea()) {
  //       return;
  //     }
  //     const locationAddress = document.getElementById("location-address");
  //     if (locationAddress && locationAddress.value) {
  //       setEditingNode({
  //         ...editingNode,
  //         address: { value: locationAddress.value }
  //       });
  //     }

  //     const validObj = { ...editingNode };
  //     const payload = {};
  //     Object.keys(validObj).forEach((key) => {
  //       if (validObj[key].value && validObj[key].value !== "") {
  //         if (key === "specifiedTimeZoneId") {
  //           payload.timeZoneId = validObj[key].value;
  //         } else if (key === "latitude" || key === "longitude") {
  //           payload[key] = JSON.parse(validObj[key].value);
  //         } else {
  //           payload[key] = validObj[key].value;
  //         }
  //       } else {
  //         delete validObj[key];
  //       }
  //     });
  //     payload.locationIds = [...selectedNodeArr];
  //     console.log("Payload::", payload);
  //   }
  // };

  const getColumns = () => {
    const columns = [];
    if (columnModel.HIERARCHY?.display) {
      columns.push({
        accessorKey: "name",
        header: t("hierarchy-nodes.locations-text")
      });
    }
    if (columnModel.APS?.display) {
      columns.push({
        accessorKey: "apCnt",
        header: t("hierarchy-nodes.aps-text")
      });
    }
    if (columnModel.CAMERA?.display) {
      columns.push({
        accessorKey: "cameraCnt",
        header: t("hierarchy-nodes.camera-text")
      });
    }
    if (columnModel.MAX_CAPACITY?.display) {
      columns.push({
        accessorKey: "maxCapacity",
        header: t("hierarchy-nodes.max-capacity-text")
      });
    }
    if (columnModel.TOTAL_AREA?.display) {
      columns.push({
        accessorKey: "totalArea",
        header: t("hierarchy-nodes.total-area-sqt-text")
      });
    }
    if (columnModel.TIME_ZONE?.display) {
      columns.push({
        accessorKey: "timeZone",
        header: t("hierarchy-nodes.time-zone-text")
      });
    }
    return columns;
  };

  const getFormattedData = (data = nodeData) => {
    const formattedData = [];
    data.forEach((node) => {
      if (node) {
        const formattedNode = {
          id: node.id,
          name: getHierarchyName(node.name),
          apCnt: node.apCnt,
          cameraCnt: node.cameraCnt,
          maxCapacity: getMaxCapacity(node),
          totalArea: getTotalArea(node),
          timeZone: node.inferredTimeZoneId ? node.inferredTimeZoneId : "Not set"
        };
        formattedData.push(formattedNode);
      }
    });
    return formattedData;
  };

  // const selectRow = (state) => {
  //   const newSelectedLocations = [];
  //   const newSelectedNodeArr = [];
  //   let groupNodeCount = 0;
  //   Object.keys(state).forEach((key) => {
  //     const node = nodeData[key];
  //     if (state[key]) {
  //       newSelectedLocations.push(node);
  //       newSelectedNodeArr.push(node.id);

  //       if (node.type[0] === "GROUP") {
  //         groupNodeCount++;
  //       }
  //     }
  //   });
  //   let newBtnVisible = { ...btnVisible };

  //   if (newSelectedNodeArr.length === 0) {
  //     newBtnVisible = { group: false, ungroup: false };
  //   } else if (groupNodeCount === 1 && newSelectedNodeArr.length === 1) {
  //     newBtnVisible = { group: false, ungroup: true };
  //   } else {
  //     newBtnVisible = { group: true, ungroup: false };
  //   }

  //   setSelectedLocations(newSelectedLocations);
  //   setSelectedNodeArr(newSelectedNodeArr);
  //   setBtnVisible(newBtnVisible);
  // };

  useEffect(() => {
    const newSelectedLocations = [];
    const newSelectedNodeArr = [];
    let groupNodeCount = 0;
    Object.keys(selectedRows).forEach((key) => {
      const node = nodeData[key];
      if (selectedRows[key]) {
        newSelectedLocations.push(node);
        newSelectedNodeArr.push(node.id);

        if (node && node.type && node.type.length > 0 && node.type[0] === "GROUP") {
          groupNodeCount++;
        }
      }
    });
    let newBtnVisible = { ...btnVisible };

    if (newSelectedNodeArr.length === 0) {
      newBtnVisible = { group: false, ungroup: false };
    } else if (groupNodeCount === 1 && newSelectedNodeArr.length === 1) {
      newBtnVisible = { group: true, ungroup: true };
    } else {
      newBtnVisible = { group: true, ungroup: false };
    }

    setSelectedLocations(newSelectedLocations);
    setSelectedNodeArr(newSelectedNodeArr);
    setBtnVisible(newBtnVisible);
  }, [selectedRows]);

  useEffect(() => {
    setFilteredLevelLocations([]);
    setSelectedLevelDown([1]);
    setSelectedTypes([]);
    setLocTypes([]);

    if (selectedNode && selectedNode.data && selectedNode.data.children) {
      setNodeData(selectedNode.data && selectedNode.data.children ? selectedNode.data.children : []);
      const childData = selectedNode.data.children;
      if (childData && childData.length) {
        setFilteredLevelLocations([...childData]);
        const tempLocTypes = [];
        childData.forEach((childDetails) => {
          if (childDetails && childDetails.type && childDetails.type.length > 0 && tempLocTypes.indexOf(childDetails.type[0]) === -1) {
            tempLocTypes.push(childDetails.type[0]);
          }
        });
        setLocTypes(tempLocTypes);
        if (tempLocTypes && tempLocTypes.length) {
          setSelectedTypes([...tempLocTypes]);
        }
      }
      // getNodeCounts(selectedNode.data.children);
    } else {
      setNodeData([]);
      const children = selectedNode && selectedNode.data && selectedNode.data.childData ? selectedNode.data.childData : null;

      const tempNodeData = [];
      if (children) {
        const tempLocTypes = [];
        children.forEach((child) => {
          if (child && child.id) {
            const childID = child.id;
            const childDetails = getLocationRowMapByKey(childID);
            tempNodeData.push(childDetails);
            if (childDetails && childDetails.type && childDetails.type.length > 0 && tempLocTypes.indexOf(childDetails.type[0]) === -1) {
              tempLocTypes.push(childDetails.type[0]);
            }
          }
        });
        setFilteredLevelLocations([...tempNodeData]);
        setLocTypes(tempLocTypes);
      }
      // getNodeCounts(tempNodeData);
    }

    const tempNodesBelow = [];
    if (selectedNode && selectedNode.data && selectedNode.data.nodesBelow) {
      for (let i = 1; i <= selectedNode.data.nodesBelow; i++) {
        tempNodesBelow.push(i);
      }
    }
    setNodesBelow(tempNodesBelow);

    resetSelectedData();
    // setSelectedNodeLevel(1);

    const tempLocAr = [];
    Object.values(getLocationRowMap()).forEach((l) => {
      tempLocAr.push(l);
    });
    setLocAr(tempLocAr);
  }, [getLocationRowMap, getLocationRowMapByKey, selectedNode]);

  useEffect(() => {
    listNodes();
  }, [selectedLevelDown, selectedTypes]);

  useEffect(() => {
    setSelectedTypes(locTypes);
  }, [locTypes]);

  return (
    <>
      <Flex direction="vertical" style={{ paddingLeft: "16px" }}>
        <Flex style={{ padding: "16px" }} gap={16}>
          <Select.MultiSelect
            label={`${t("hierarchy-nodes.level-text")}: ${getLevel()} - 
          ${filteredLevelLocations.length} locations`}
            onChange={(level) => {
              toggleFilter(level);
            }}
            onClear={clearFilter}
            value={nodesBelow.filter((level) => isChecked(level))}
            options={nodesBelow.map((level) => ({
              label: `${level} ${t("hierarchy-nodes.levels-down-text")}`,
              value: level
            }))}
          />
          <Select.MultiSelect
            label={`${t("hierarchy-nodes.location-type-text")}: ${getType()} - 
            ${nodeData?.length} locations`}
            onChange={(type) => {
              toggleType(type);
            }}
            onClear={clearTypeFilter}
            value={locTypes.filter((type) => isTypeChecked(type))}
            options={locTypes.map((type) => ({
              label: type,
              value: type
            }))}
          />
        </Flex>
        <Flex style={{ padding: "16px" }}>
          <Flex direction="vertical" style={{ width: "100%" }} gap={16}>
            {selectedNode?.data?.access === "Full" && nodeData?.length > 0 && selectedNodeArr.length > 0 && (
              <Flex justify="space-between" style={{ padding: "0 8px" }}>
                <Text>
                  {selectedNodeArr.length} {t("hierarchy-nodes.selected-text")}
                </Text>
                <Button.Group>
                  {btnVisible.group && (
                    <Button kind="tertiary" onClick={openCreateGroupPopup}>
                      Create Group
                    </Button>
                  )}
                  {btnVisible.ungroup && (
                    <Button kind="tertiary" onClick={toggleUngroupConfirmation}>
                      Ungroup
                    </Button>
                  )}
                </Button.Group>
              </Flex>
            )}
            {nodeData?.length > 0 && (
              <Flex>
                <MTable.Pagination key={nodeData.length} currentPage={1} defaultRecordsOption="10" showNavigation="all" showOptions showTotal>
                  <MTable
                    onRowSelectionChange={setRowSelection}
                    rowSelection={selectedRows}
                    selectableRows={columnModel.SELECT?.display}
                    columns={getColumns()}
                    data={getFormattedData()}
                    // getSelectedRows={(state) => selectRow(state)}
                  />
                </MTable.Pagination>
              </Flex>
            )}
            {nodeData?.length === 0 && (
              <Flex align="center" justify="center">
                <Text>{t("hierarchy-nodes.no-nodes-found-text")}</Text>
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>
      <CreateGroupPopup
        groupPopupVisible={groupPopupVisible}
        closeGroupPopup={closeGroupPopup}
        createGroup={createGroup}
        groupName={groupName}
        setGroupName={setGroupName}
        setModalOpened={setModalOpened}
        selectedGroupData={selectedGroupData}
      />
      <UngroupPopup unGroupPromptVisible={unGroupPromptVisible} toggleUngroupConfirmation={toggleUngroupConfirmation} ungroupSelectedNode={ungroupSelectedNode} />
    </>
  );
}

export default HierarchyNodes;
